import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./ProductTile.scss";

const ProductTileVisuals = forwardRef(
  ({ children, customClass, ...restProps }, ref) => {
    return (
      <div
        ref={ref}
        className={cx(styles.visualGroup, customClass)}
        {...restProps}
      >
        {children}
      </div>
    );
  }
);

ProductTileVisuals.displayName = "ProductTile.Visuals";

ProductTileVisuals.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  customClass: PropTypes.string,
};

ProductTileVisuals.defaultProps = {
  children: undefined,
  customClass: undefined,
};

export default ProductTileVisuals;
